import React from "react";
import { useTranslation } from "react-i18next";
import { ElementRoot } from "./ElementRoot.jsx";

export const NotFoundPreview = () => {
  const { t } = useTranslation();
  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <div className="ang_preview_image ang_preview_image_failed" />
          <div className="ang_preview_message">
            <p>{t("File is missing.")}</p>
            <p>{t("Please contact the system administrator.")}</p>
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};
